<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-search-btn">
        <!-- <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入用户ID/手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button> -->
      </div>
      <el-button style="margin-right:16px;" @click="handleAdd(null)" type="primary">新增</el-button>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table v-loading="isLoading" :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" label="优惠劵名称">
              <template slot-scope="scope">
                <div>{{ scope.row.coupon_name }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="优惠劵描述">
              <template slot-scope="scope">
                <div>{{ scope.row.coupon_description }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="优惠劵有效期">
              <template slot-scope="scope">
                <div v-if="scope.row.coupon_expire">{{ scope.row.coupon_expire }}天</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="目标群体">
              <template slot-scope="scope">
                <span v-if="parseInt(scope.row.target)===11">全部 </span>
                <span v-else>{{ targetList[parseInt(scope.row.target)] }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="每个用户发劵数量">
              <template slot-scope="scope">
                <span>{{ scope.row.couponcount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="任务状态">
              <template slot-scope="scope">
                <span>{{ statusList[parseInt(scope.row.status)] }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="已发劵总数">
              <template slot-scope="scope">
                <span>{{ scope.row.statistics_total }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="已使用数量">
              <template slot-scope="scope">
                <span>{{ scope.row.statistics_used }} </span>
              </template>
            </el-table-column>
           <el-table-column width="160" align="center" label="创建时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createtime }} </span>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="handleCopy(scope.row)" size="mini">
                  <span>复制</span>
                </el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" layout="prev, pager, next" :current-page="page" :page-size="pageSize" :total="total">
      </el-pagination>
    </el-container>
    <recharge-modal ref="rechargeModal" @ok="loadData"></recharge-modal>
  </el-container>
</template>
<script>
import { getSendCouponList } from '@/views/webpc/MemberManagement/SendCouponList/apis'
import RechargeModal from './modules/RechargeCouponModal'
export default {
  components: { RechargeModal },
  data () {
    return {
      isLoading: false,
      pageSize: 20,
      page: 1,
      total: 0,
      radio: '1',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      valuedate: null,
      valueid: '',
      tableData: [],
      targetList: ['未定义', '死粉', '中粉', '活粉', '忠粉', '普粉', '全部'],
      statusList: ['未完成', '发劵中', '发劵完成', '任务异常']
    }
  },
  methods: {
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    loadData () {
      this.isLoading = true
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      getSendCouponList(data)
        .then((result) => {
          this.isLoading = false
          if (result) {
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        })
        .catch((error) => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    handleAdd (obj) {
      this.$refs.rechargeModal.show(obj)
    },
    handleCopy (obj) {
      this.$refs.rechargeModal.show(obj)
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/MemberManagement/SendCouponList/SendCoupon.vue